import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/tag.svg';

export const IconTag: IconComponent = props => <Icon {...props} src={src} />;
